import { Chat } from '../../../../components/Chat/Chat'
import { Demo, DsSection } from '../primitives'
import { MOCK_APPLICATION, MOCK_MESSAGES } from './insuranceApplicationMocks'

export function ChatSection() {
  return (
    <DsSection id="chat" title="Chat">
      <Demo label="Chat" className="bg-ink-50 rounded-sm p-8">
        {/* The application page's chat column width. */}
        <div className="max-w-130">
          {/* Without this the demo scrolls the whole design system to its own last message. */}
          <Chat
            messages={MOCK_MESSAGES}
            sendMessage={() => undefined}
            application={MOCK_APPLICATION}
            disableAutoScroll
          />
        </div>
      </Demo>
    </DsSection>
  )
}
